import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { getDynamicSignUpURL } from "../requests/user"
import { API_Data_DynamicSignUpURL_Response } from "@/interfaces/api/signup/api_response_types"

type DynamicSignUpOptions = Omit<
  UseQueryOptions<API_Data_DynamicSignUpURL_Response, API_Error, API_Data_DynamicSignUpURL_Response, ['dynamicSignUpURL']>,
  'queryKey' | 'queryFn'
>

export const useDynamicSignUpURL = (options?: DynamicSignUpOptions) => 
  useQuery<API_Data_DynamicSignUpURL_Response, API_Error, API_Data_DynamicSignUpURL_Response, ['dynamicSignUpURL']>({
    queryKey: ['dynamicSignUpURL'],
    retry: false,
    queryFn: getDynamicSignUpURL,
    ...options
  })